import { restAxios } from './httpClient';
import { stripBlankParams } from '../helpers/queryParams';

const ACTIVATION_KEYS_PATH = '/v1/licensing/activation-keys';

/*
 * Paging and typing a key fire a request per gesture, and the responses can come back out of
 * order. Aborting the in-flight read keeps the table showing the latest page or key rather than
 * whichever response happened to land last.
 */
let getActivationKeysController;

/*
 * One page of activation keys, newest first, or the one key `productKey` names in full (SYN-3449).
 * A blank `productKey` is dropped from the query: the server reads a part of a key as a key that
 * matches nothing, so the box's own emptiness must not travel.
 */
export const getActivationKeys = (queryParams) => {
	getActivationKeysController?.abort();

	getActivationKeysController = new AbortController();
	const searchParams = new URLSearchParams(stripBlankParams(queryParams)).toString();

	return restAxios.get(`${ACTIVATION_KEYS_PATH}?${searchParams}`, {
		signal: getActivationKeysController.signal
	});
};
